<template>
  <div :id="`modal-${modalId}`">
    <div class="modal"
         tabindex="-1"
         role="dialog"
         :class="modalClasses">
      <div class="modal-dialog"
           :class="dialogClasses"
           role="document">
        <div class="modal-content">
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer border-0"
               v-if="showButtons">
            <a :href="modalUrl"
               :class="leaveButtonClasses"
               :target="target"
               class="btn btn-success btn-round me-sm-3"
               @click="$emit('leaveLinkClicked', modal)">
              Proceed
            </a>
            <a href="javascript:void(0)"
               class="btn btn-outline-primary btn-round"
               @click="$emit('stayLinkClicked', modal)">
              Stay here
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop cb-speedbump-backdrop"></div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { v4 as uuid } from 'uuid';

export default {
  name: 'Modal',
  props:{
    modalOptions: {
      type: Object
    },
    modalClasses: {
      type: String,
      default: ''
    },
    dialogClasses: {
      type: String,
      default: ''
    },
    newWindow: {
      type: Boolean,
      default: true
    },
    modalUrl: {
      type: String,
      default: 'javascript:void(0)'
    },
    leaveButtonClasses: {
      type: String,
      default: ''
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const modalId = uuid();
    let modalBackdrop = undefined;
    let modalElement = undefined;
    let modal = undefined;

    const target = props.newWindow ? '_blank' : '_self';

    const initModal = () => {
      const wrapper = document.getElementById(`modal-${modalId}`);
      modalElement = wrapper.querySelector('.modal');
      modalBackdrop = wrapper.querySelector('.cb-speedbump-backdrop');
      const options = props.modalOptions || {
        backdrop: false,
        keyboard: true,
        focus: true
      };

      modal = new Modal(modalElement, options);
    };

    onMounted(() => {
      initModal();

      modalElement.addEventListener('show.bs.modal', () => {
        if (modalBackdrop) {
          modalBackdrop.classList.add('show');
        }
      });

      modalElement.addEventListener('hide.bs.modal', () => {
        if (modalBackdrop) {
          modalBackdrop.classList.remove('show');
        }
      });

      emit('modalMounted', modal);
    });

    return {
      modalId,
      modal,
      target
    };
  },
};
</script>
